import { signalStore, withState, withMethods, patchState } from "@ngrx/signals";
import { FormErrorResponse, initialState } from "./api-state.model";
import { UtilHttpErrorHelper } from "@rr/shared-util";

export const ApiStore = signalStore(
  { providedIn: "root" },
  withState(initialState),
  withMethods((store) => ({
    clearError() {
      patchState(store, { show: false, errorMessage: null });
    },
    setApiError(errorResponse: FormErrorResponse | null, errorConfirmCallback: (() => void) | null = null) {
      patchState(store, {
        show: true,
        errorMessage: UtilHttpErrorHelper.getErrorMessage(
          errorResponse as unknown as { errors: { detail: string }[] } | null,
        ),
        errorConfirmCallback: errorConfirmCallback,
      });
    },
  })),
);
